var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppBranding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1088,
    viewBox: "0 0 1024 1088",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M789.032 258.205C862.449 214.12 957.755 237.858 1001.84 311.275C1045.93 384.693 1022.19 479.955 948.771 524.084C875.353 568.17 780.092 544.431 735.962 471.014C691.832 397.597 715.615 302.291 789.032 258.205Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M720.821 339.709C720.821 339.709 671.583 467.694 526.334 548.951C526.334 548.951 829.119 598.189 954.682 516.933L720.821 339.709Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M694.607 692.148C731.558 614.899 824.178 582.22 901.426 619.171C978.675 656.166 1011.35 748.741 974.403 826.034C937.452 903.283 844.833 935.962 767.584 898.967C690.291 862.016 657.656 769.397 694.607 692.148Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M797.14 608.023C797.14 608.023 661.756 637.53 516.507 561.25C516.507 561.25 644.536 841.883 777.454 900.943L797.14 608.023Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.903 0C641.564 0 710.973 69.4536 710.973 155.07C710.973 240.731 641.564 310.141 555.903 310.141C470.242 310.141 400.832 240.731 400.832 155.07C400.832 69.4536 470.242 0 555.903 0Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.757 256.014C437.757 256.014 521.436 364.312 516.548 529.248C516.548 529.248 713.457 292.921 710.991 147.716L437.757 256.014Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2293 570.302C148.647 526.217 243.953 549.955 288.038 623.373C332.124 696.79 308.385 792.052 234.968 836.181C161.551 880.267 66.2888 856.529 22.1592 783.111C-21.9264 709.694 1.81197 614.388 75.2293 570.302Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.89 753.245C299.89 753.245 349.128 625.26 494.377 544.047C494.377 544.047 191.591 494.765 66.0288 576.021L299.89 753.245Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0694 267.903C79.0203 190.655 171.64 157.976 248.889 194.927C326.182 231.922 358.816 324.497 321.865 401.79C284.915 479.039 192.295 511.718 115.046 474.723C37.7533 437.772 5.11849 345.152 42.0694 267.903Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.116 484.925C221.116 484.925 356.5 455.417 501.749 531.697C501.749 531.697 373.72 251.064 240.803 192.004L221.116 484.925Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.359 777.867C548.02 777.867 617.429 847.321 617.429 932.938C617.429 1018.6 548.02 1088.01 462.359 1088.01C376.698 1088.01 307.288 1018.6 307.288 932.938C307.288 847.321 376.698 777.867 462.359 777.867Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.526 834.484C580.526 834.484 496.847 726.186 501.736 561.25C501.736 561.25 304.826 797.578 307.293 942.783L580.526 834.484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppBranding);
export default __webpack_public_path__ + "static/media/app-branding.f14e55f507746fa2af135acbed3f8df6.svg";
export { ForwardRef as ReactComponent };